import { render, staticRenderFns } from "./CatalogTemplates.vue?vue&type=template&id=60062ea4&"
import script from "./CatalogTemplates.vue?vue&type=script&lang=js&"
export * from "./CatalogTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports